import "@/App.css";
import "@/pages/HomePage.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import Dashboard from "@/pages/Dashboard";
import AdminPage from "@/pages/AdminPage";
import OpsDashboard from "@/pages/OpsDashboard";
import FleetStatus from "@/pages/FleetStatus";
import VideoLibrary from "@/pages/VideoLibrary";
import CustomerDownload from "@/pages/CustomerDownload";
import AircraftTracker from "@/pages/AircraftTracker";
import WeatherChatPage from "@/pages/WeatherChatPage";
import XkAiLegs from "@/pages/XkAiLegs";
import PasswordGate from "@/components/PasswordGate";
import AdminGate from "@/components/AdminGate";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";

// Inner app component that uses theme
function AppContent() {
  const { theme } = useTheme();
  
  return (
    <BrowserRouter>
      <Routes>
        {/* Public customer download page - no password required */}
        <Route path="/download" element={<CustomerDownload />} />
        
        {/* Standalone Weather Chat - trigram authentication only */}
        <Route path="/chat" element={<WeatherChatPage />} />
        
        {/* All other routes protected by main PasswordGate */}
        <Route path="/*" element={
          <PasswordGate>
            <div className={`min-h-screen app-container ${theme}`}>
              <div className="noise-overlay" />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/brief" element={<Dashboard />} />
                <Route path="/ops" element={<OpsDashboard />} />
                <Route path="/video-library" element={<VideoLibrary />} />
                <Route path="/tracker" element={<AircraftTracker />} />
                {/* Admin and Fleet require additional authentication */}
                <Route path="/admin" element={
                  <AdminGate>
                    <AdminPage />
                  </AdminGate>
                } />
                <Route path="/fleet" element={
                  <AdminGate>
                    <FleetStatus />
                  </AdminGate>
                } />
                {/* Hidden XkAiLegs module - flight operations management */}
                <Route path="/xkailegs" element={
                  <AdminGate>
                    <XkAiLegs />
                  </AdminGate>
                } />
              </Routes>
              <Toaster position="top-right" theme={theme} />
              <PWAInstallPrompt />
            </div>
          </PasswordGate>
        } />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
